import React from 'react';
import './App.css';
import Navbar from './components/Navbar/Navbar';
import NavItem from './components/Navbar/NavItem';
import DropdownMenu from './components/Navbar/DropdownMenu';
import Header from './components/Header/Header';
import Skills from './components/Skills/Skills';
import ProjectsPage from './components/Projects/ProjectsPage';
import { ReactComponent as DownArrow } from './icons/down-arrow.svg';
import Home from "./pages/Home";
import Hobbies from './components/Hobbies/Hobbies';
import Contact from './components/Contact/Contact';
import "./App.scss";

function App() {
  return (
    <>
    <Navbar>
      <NavItem icon={ <DownArrow /> }>
        <DropdownMenu />
      </NavItem>
    </Navbar>
    <Header />
    <div className="App" style={{ marginTop: '40px', paddingBottom: '40px' }}>
      <Home />
    </div>
    <Skills />
    <ProjectsPage />
    <Hobbies />
    <Contact />
    <div style={{ textAlign: 'center', backgroundColor: '#ebebeb', paddingBottom: '20px' }}>
      <h4 style={{ margin: '0 20px' }}>© Copyright 2020 Swapnil Sengupta</h4>
    </div>
    </>
  );
}

export default App;
